var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddFriend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddFriend") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Empty-state",
    transform: "translate(-118.000000, -2232.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 2086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/buttons/pill",
    transform: "translate(86.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAddFriend",
    transform: "translate(15.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1103389,5.9831746 L16.3896611,5.9831746 L16.3896611,4.0167318 C16.3896611,3.45529216 15.991435,3 15.5,3 C15.008565,3 14.6103389,3.45529216 14.6103389,4.0167318 L14.6103389,5.9831746 L12.8896611,5.9831746 C12.3982262,5.9831746 12,6.43846676 12,6.9999064 C12,7.56134603 12.3982262,8.0166382 12.8896611,8.0166382 L14.6103389,8.0166382 L14.6103389,9.9832682 C14.6103389,10.5447078 15.008565,11 15.5,11 C15.991435,11 16.3896611,10.5447078 16.3896611,9.9832682 L16.3896611,8.0168254 L18.1103389,8.0168254 C18.6017738,8.0168254 19,7.56153324 19,7.0000936 C19,6.43846676 18.6017738,5.9831746 18.1103389,5.9831746 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9724238,15.9816514 C11.5471698,15.9816514 12,15.5045872 12,14.8990826 C12,14.8807339 12,14.8807339 12,14.8623853 C12,11.1009174 9.31785196,8 5.99129173,8 C2.66473149,8 0,11.1376147 0,14.8990826 C0,14.8990826 0,14.8990826 0,14.9174312 C0,15.5229358 0.470246734,16 1.0275762,16 L10.9724238,15.9816514 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.5,
    cy: 3.5,
    r: 3.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddFriend);
export default __webpack_public_path__ + "static/media/icAddFriend.b865a5bea1683398116b1756663e0a8b.svg";
export { ForwardRef as ReactComponent };